import categories from './categories'

// import whiteChair from '../assets/white-bg-chair-table.jpg'
// import desktopTable from '../assets/white-bg-desktop.jpg'
// import computerTable from '../assets/computer-table.jpg'
// import keyboard from '../assets/keyboard.jpg'
// import mouse from '../assets/mouse.jpg'
// import headphones from '../assets/headphones.jpg'
// import hipsterHeadphones from '../assets/hipster-headphones.jpg'
// import vintagePhone from '../assets/vintage-phone.jpg'

// const itemData = [
//     {   
//         id: 1,
//         name:"White Chair",
//         price: 630,
//         tag: "Hot",
//         image: whiteChair
//     },
//     {   
//         id: 2,
//         name:"Desktop Table",
//         price: 630,
//         tag: "New",
//         image: desktopTable
//     },
//     {   
//         id: 3,
//         name:"Keyboard",
//         price: 120,
//         tag: null,
//         image: keyboard
//     },
//     {   
//         id: 4,
//         name:"Mouse",
//         price: 630,
//         tag: "Hot",
//         image: mouse
//     },
//     {   
//         id: 5,
//         name:"Computer Table",
//         price: 1200,
//         tag: "New",
//         image: computerTable
//     },
//     {   
//         id: 6,
//         name:"White Chair",
//         price: 630,
//         tag: "Hot",
//         image: whiteChair
//     },
//     {   
//         id: 7,
//         name:"Headphones",
//         price: 30,
//         tag: null,
//         image: headphones
//     },
//     {   
//         id: 8,
//         name:"Vintage Headpones",
//         price: 450,
//         tag: "Hot",
//         image: hipsterHeadphones
//     },
// ]

let itemData = [{
  "id": 1,
  "name": "Kissed",
  "price": 397
}, {
  "id": 2,
  "name": "Cold Weather",
  "price": 805
}, {
  "id": 3,
  "name": "Primus Hallucino-Genetics Live 2004",
  "price": 926
}, {
  "id": 4,
  "name": "Maze, The",
  "price": 111
}, {
  "id": 5,
  "name": "Rebellion (L'ordre et la morale)",
  "price": 1153
}, {
  "id": 6,
  "name": "2010: The Year We Make Contact",
  "price": 588
}, {
  "id": 7,
  "name": "Suddenly, Last Summer",
  "price": 115
}, {
  "id": 8,
  "name": "End of Love, The",
  "price": 484
}, {
  "id": 9,
  "name": "Forgive Me",
  "price": 1032
}, {
  "id": 10,
  "name": "Captain Phillips",
  "price": 497
}, {
  "id": 11,
  "name": "East Side Story",
  "price": 874
}, {
  "id": 12,
  "name": "Hoop Realities",
  "price": 490
}, {
  "id": 13,
  "name": "Cat Ballou",
  "price": 202
}, {
  "id": 14,
  "name": "Divorce Iranian Style",
  "price": 417
}, {
  "id": 15,
  "name": "Once Bitten",
  "price": 946
}, {
  "id": 16,
  "name": "Happy People: A Year in the Taiga",
  "price": 918
}, {
  "id": 17,
  "name": "Once Upon a Time in the Midlands",
  "price": 1041
}, {
  "id": 18,
  "name": "Mental",
  "price": 1184
}, {
  "id": 19,
  "name": "Winter Sleep (Kis Uykusu)",
  "price": 300
}, {
  "id": 20,
  "name": "Nocturna",
  "price": 937
}, {
  "id": 21,
  "name": "Back Door to Hell",
  "price": 156
}, {
  "id": 22,
  "name": "The Mark of Cain",
  "price": 855
}, {
  "id": 23,
  "name": "Papa's Delicate Condition",
  "price": 726
}, {
  "id": 24,
  "name": "Boogie (Boogie, el aceitoso)",
  "price": 497
}, {
  "id": 25,
  "name": "Advanced Style",
  "price": 637
}, {
  "id": 26,
  "name": "Lucifer Rising",
  "price": 518
}, {
  "id": 27,
  "name": "Lion King, The",
  "price": 577
}, {
  "id": 28,
  "name": "A.C.O.D.",
  "price": 1182
}, {
  "id": 29,
  "name": "Grand, The",
  "price": 471
}, {
  "id": 30,
  "name": "America's Most Haunted Inns",
  "price": 171
}, {
  "id": 31,
  "name": "Behind Enemy Lines",
  "price": 839
}, {
  "id": 32,
  "name": "Pinochet Case, The (Cas Pinochet, Le)",
  "price": 1014
}, {
  "id": 33,
  "name": "Mondo Cane",
  "price": 285
}, {
  "id": 34,
  "name": "Peace, Love & Misunderstanding",
  "price": 894
}, {
  "id": 35,
  "name": "Roots",
  "price": 240
}, {
  "id": 36,
  "name": "Prophecy 3: The Ascent, The",
  "price": 1188
}, {
  "id": 37,
  "name": "Woman Under the Influence, A",
  "price": 992
}, {
  "id": 38,
  "name": "Material Girls",
  "price": 868
}, {
  "id": 39,
  "name": "Thrill Ride: The Science of Fun",
  "price": 1083
}, {
  "id": 40,
  "name": "The Woodcarver",
  "price": 562
}, {
  "id": 41,
  "name": "Ai Weiwei: Never Sorry",
  "price": 678
}, {
  "id": 42,
  "name": "Who Is Cletis Tout?",
  "price": 1128
}, {
  "id": 43,
  "name": "Naked Gun: From the Files of Police Squad!, The",
  "price": 539
}, {
  "id": 44,
  "name": "Italian Job, The",
  "price": 447
}, {
  "id": 45,
  "name": "Dodes'ka-den (Clickety-Clack)",
  "price": 758
}, {
  "id": 46,
  "name": "Innocent Sleep, The",
  "price": 587
}, {
  "id": 47,
  "name": "Little Man Tate",
  "price": 551
}, {
  "id": 48,
  "name": "North Star, The",
  "price": 997
}, {
  "id": 49,
  "name": "Johnny Was",
  "price": 570
}, {
  "id": 50,
  "name": "Michael",
  "price": 156
}, {
  "id": 51,
  "name": "Mimic 2",
  "price": 606
}, {
  "id": 52,
  "name": "Simple Simon (I rymden finns inga känslor)",
  "price": 924
}, {
  "id": 53,
  "name": "Mi Amigo Hugo",
  "price": 1193
}, {
  "id": 54,
  "name": "39 Steps, The",
  "price": 1119
}, {
  "id": 55,
  "name": "Dave Chappelle: For What it's Worth",
  "price": 311
}, {
  "id": 56,
  "name": "California Solo",
  "price": 988
}, {
  "id": 57,
  "name": "Railway Man, The",
  "price": 1179
}, {
  "id": 58,
  "name": "Dorian Blues",
  "price": 427
}, {
  "id": 59,
  "name": "Lonesome Jim",
  "price": 673
}, {
  "id": 60,
  "name": "Trick",
  "price": 758
}, {
  "id": 61,
  "name": "Midnight Clear",
  "price": 1055
}, {
  "id": 62,
  "name": "Jimi Hendrix",
  "price": 739
}, {
  "id": 63,
  "name": "Crime Zone",
  "price": 1021
}, {
  "id": 64,
  "name": "Tis kakomoiras",
  "price": 219
}, {
  "id": 65,
  "name": "Winning Streak",
  "price": 861
}, {
  "id": 66,
  "name": "Phantom Lover, The (Ye ban ge sheng)",
  "price": 127
}, {
  "id": 67,
  "name": "Unhook the Stars",
  "price": 998
}, {
  "id": 68,
  "name": "How I Won the War",
  "price": 1047
}, {
  "id": 69,
  "name": "Cave of Forgotten Dreams",
  "price": 688
}, {
  "id": 70,
  "name": "Somewhere",
  "price": 127
}, {
  "id": 71,
  "name": "Hell's Highway",
  "price": 798
}, {
  "id": 72,
  "name": "Divine Horsemen: The Living Gods of Haiti",
  "price": 411
}, {
  "id": 73,
  "name": "Super Capers",
  "price": 945
}, {
  "id": 74,
  "name": "America: Imagine the World Without Her",
  "price": 412
}, {
  "id": 75,
  "name": "Dreamer: Inspired by a True Story",
  "price": 472
}, {
  "id": 76,
  "name": "Wartorn: 1861-2010",
  "price": 610
}, {
  "id": 77,
  "name": "Foxfire",
  "price": 423
}, {
  "id": 78,
  "name": "Midsummer Night's Dream, A",
  "price": 1073
}, {
  "id": 79,
  "name": "United",
  "price": 647
}, {
  "id": 80,
  "name": "Steel",
  "price": 1092
}, {
  "id": 81,
  "name": "Conquest",
  "price": 447
}, {
  "id": 82,
  "name": "Oxygen",
  "price": 775
}, {
  "id": 83,
  "name": "Wonderful and Loved by All (Underbar och älskad av alla)",
  "price": 420
}, {
  "id": 84,
  "name": "Dead Ringer",
  "price": 886
}, {
  "id": 85,
  "name": "Masquerade",
  "price": 556
}, {
  "id": 86,
  "name": "La guerre des tuques",
  "price": 1054
}, {
  "id": 87,
  "name": "Lone Ranger, The",
  "price": 1128
}, {
  "id": 88,
  "name": "Dr. Goldfoot and the Girl Bombs (Le spie vengono dal semifreddo)",
  "price": 431
}, {
  "id": 89,
  "name": "Went to Coney Island on a Mission From God... Be Back by Five",
  "price": 1190
}, {
  "id": 90,
  "name": "Wrestling Queens",
  "price": 1067
}, {
  "id": 91,
  "name": "Any Wednesday (Bachelor Girl Apartment)",
  "price": 881
}, {
  "id": 92,
  "name": "Wheelmen",
  "price": 155
}, {
  "id": 93,
  "name": "You Were Never Lovelier",
  "price": 868
}, {
  "id": 94,
  "name": "Adonis Factor, The",
  "price": 832
}, {
  "id": 95,
  "name": "Adventures in Zambezia",
  "price": 1002
}, {
  "id": 96,
  "name": "War at Home, The",
  "price": 1148
}, {
  "id": 97,
  "name": "Blair Witch Project, The",
  "price": 672
}, {
  "id": 98,
  "name": "Dominick and Eugene",
  "price": 999
}, {
  "id": 99,
  "name": "Kites",
  "price": 368
}, {
  "id": 100,
  "name": "RKO 281",
  "price": 585
}]

//   import whiteChair from '../assets/white-bg-chair-table.jpg'
// import desktopTable from '../assets/white-bg-desktop.jpg'
// import computerTable from '../assets/computer-table.jpg'
// import keyboard from '../assets/keyboard.jpg'
// import mouse from '../assets/mouse.jpg'
// import headphones from '../assets/headphones.jpg'
// import hipsterHeadphones from '../assets/hipster-headphones.jpg'


// const categories = [
//   { 
//       name:"headphones",
//       subCategories: ["vintage", "gamer"],
//       image: headphones
//   }, 
//   {
//       name:"keyboards",
//       subCategories: ["vintage", "office", "gamer"],
//       image: keyboard
//   }, 
//   {
//       name:"computers",
//       subCategories: ["desktop", "laptop", "gaming", "tablet"],
//       image: computerTable
//   },
//   {
//       name:"phones",
//       subCategories: ["android", "Apple", "vintage"],
//       image: vintagePhone
//   }, 
//   {
//       name:"tables",
//       subCategories: ["standing", "office", "drawing"],
//       image: desktopTable
//   }, 
//   {
//       name:"chairs",
//       subCategories: ["gaming", "vintage", "office", "rocking"],
//       image: whiteChair
//   }
// ]

const rand = (num) => {
    return Math.floor(Math.random()*(num+1))
}

itemData.forEach((i) => {

    let c = categories[rand(categories.length-1)]

    i.category = c.name;
    i.image = c.image

    i.subCategory = c.subCategories[rand(c.subCategories.length-1)]

    if(i.id % 7 === 0) {
        i.tag = "Hot";
    } else if(i.id % 7 === 1) {
        i.tag = "Hot"
    }else if(i.id % 7 === 2) {
        i.tag = ""
    }else if(i.id % 7 === 3) {
        i.tag = "New"
    } else if(i.id % 7 === 4) {
        i.tag = "Hot"
    } else if(i.id % 7 === 5) {
        i.tag = "New"
    } else if(i.id % 7 === 6) {
        i.tag = ""
    }
});


// console.log(itemData)

export default itemData